const resultPage = {
  path: '/result-page',
  component: () => import('@/views/result-page/index'),
  name: 'Result-Page',
  meta: {
    title: '出单结果'
  }
}
export default resultPage
